import script from "./CheckoutPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckoutPage.vue?vue&type=script&setup=true&lang=ts"

import "./CheckoutPage.vue?vue&type=style&index=0&id=c570a21e&scoped=true&lang=css"

import exportComponent from "../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c570a21e"]])

export default __exports__